import { h, Component } from 'preact';

import FontAwesomeIcon from './fontAwesomeIcon.js';
//import { faPhone } from '@fortawesome/free-solid-svg-icons';
//import { faEdit } from '@fortawesome/pro-solid-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import ContractorPhoneMumber from './contractorPhoneNumber.js';

import style from '../../style/contractorList.sass';

const getPrimaryAddress = (addresses)=>{
  if(Array.isArray(addresses)){
    return addresses.find(address=>{
      return (address.isPrimary === true);
    });
  }
  return {};
};

const getMilesFromMeters = (meters) => {
  return Math.round(meters / 1600);
};

const getContractorListItemStyleClassNames = (brand) => {
  if(brand === 'rheem'){
    return {
      brandFontStyle: style.contractorListItemFont,
      contractorFormLinkStyle: style.contractorFormLink
    };
  }
  if(brand === 'ruud'){
    return {
      brandFontStyle: style.contractorListItemFontRuud,
      contractorFormLinkStyle: style.contractorFormLinkRuud
    };
  }
  if(brand === 'friedrich'){
    return {
      brandFontStyle: style.contractorListItemFontFriedrich,
      contractorFormLinkStyle: style.contractorFormLinkFriedrich
    };
  }
  return {
    brandFontStyle: style.contractorListItemFont,
    contractorFormLinkStyle: style.contractorFormLink
  };
};

const getContractorListSearchBarStyleClassNames = (brand) => {
  const classNames = [style.listSearchBar];
  if(brand === 'ruud'){
    classNames.push(style.listSearchBarRuud);
  }
  if(brand === 'friedrich'){
    classNames.push(style.listSearchBarFriedrich);
  }
  return classNames;
};

//<p className={[style.contractorListItemNameAddressBottom, brandFontStyle].join(' ')}>{getMilesFromMeters(props.contractor.distance)} miles</p>

const ContractorListItem = props => {
  const classNames = getContractorListItemStyleClassNames(props.brand);
  const primaryAddress = getPrimaryAddress(props.contractor.addresses);
  return (
    <li className={style.contractorListItem}>
      <div className={style.contractorListItemInnerContainer}>
        <div className={style.contractorListItemLeftContainer}>
          <h4 className={[style.contractorListItemName, classNames.brandFontStyle].join(' ')}>
            {props.contractor.name.toUpperCase()}
          </h4>
          <p className={[style.contractorListItemNameAddressTop, classNames.brandFontStyle].join(' ')}>
            {primaryAddress.street}
          </p>
          <p className={[style.contractorListItemNameAddressMiddle, classNames.brandFontStyle].join(' ')}>{
            primaryAddress.city}, {primaryAddress.state} {primaryAddress.zip}
          </p>
        </div>
        <div className={style.contractorListItemRightContainer}>
          <ContractorPhoneMumber {...props} contractor={props.contractor} style={{color: '#616265', fontSize: '16pt', fontWeight: 'bold'}} />
          <button onClick={(e)=>{
            e.preventDefault();
            props.showForm(props.contractor);
          }} className={classNames.contractorFormLinkStyle}>
            SCHEDULE NOW
          </button>
        </div>
      </div>
    </li>
  );
};

//<FontAwesomeIcon icon={faEdit} /> &nbsp;

export default class ContractorList extends Component {
  constructor(props) {
    super(props);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.state = {
      distance: '40',
      zip: ''
    };
  }
  handleSearchInputChange(e){
    this.setState({[e.target.name]: e.target.value});
  }
  onSearchClick(e){
    e.preventDefault();
    this.props.setSearchLocation({...this.state});
  }
  render(props, state) {
    const contractors = Array.isArray(props.contractors)?props.contractors:[];
    const spinner = this.props.formSendPending?<FontAwesomeIcon icon={faSpinner} pulse />:null;
    const searchClassNames = getContractorListSearchBarStyleClassNames(props.brand);
    return (
      <div id="contractor-list" className={style.container}>
        <div id="contractor-list-search-bar" className={searchClassNames.join(' ')}>
          <span className={style.listSearchBarInputGroup}>
            <label>DISTANCE</label>
            <select name="distance" value={this.state.distance} onChange={this.handleSearchInputChange} >
              <option value="16">10 miles</option>
              <option value="40">25 miles</option>
              <option value="80">50 miles</option>
            </select>
          </span>
          <span className={style.listSearchBarInputGroup}>
            <label>ZIP</label>
            <input value={this.state.zip} name="zip" onChange={this.handleSearchInputChange} />
          </span>
          <span className={style.listSearchBarInputGroup}>
            <button type="button" onClick={this.onSearchClick} disabled={this.props.formSendPending}>
              SEARCH
              {spinner}
            </button>
          </span>
        </div>
        <ul className={style.contractorList}>
          {contractors.map(contractor=>{
            return (<ContractorListItem {...props} contractor={contractor} />);
          })}
        </ul>
      </div>
    );
  }
}
